<template>
  <v-container>
    <h2 style="color: gray">Cài đặt hỗ trợ học phí</h2>
    <v-divider class="my-3"></v-divider>
    <v-row>
      <v-col cols="12">
        <v-checkbox
          v-model="policies"
          value="view-student-ticket"
          hide-details
          :label="'Cho phép ' + roleName + ' xem ticket'"
          class="ma-0 px-0 py-3"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-divider class="my-3"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text class="mx-5" @click="reset()">Đặt lại</v-btn>
      <v-btn color="primary" @click="save()">Lưu</v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
import mixins from './helper/mixins'
export default {
  mixins: [mixins],
}
</script>

<style scoped></style>
